export default {
  createEvent: 'Ereignis erstellen',
  editEvent: 'Bearbeiten: {0}',
};
